import React from 'react';
import {
  cadStockLegendDotStyle,
  cadStockLegendItemButtonStyle,
  cadStockLegendItemStyle,
  cadStockLegendRootStyle,
} from './CadStockLegend.styles';
import { isCadStockStatusVisible } from '../utils/cadStockStatus';

/**
 * Leyenda flotante de stock CAD (mismos colores que el overlay).
 * Con `onToggle`, cada badge filtra ese estado en el mapa.
 *
 * @param {object} props
 * @param {{ id: string, label: string, color: string }[]} [props.items]
 * @param {Record<string, boolean>|null} [props.visibility]
 * @param {(statusId: string) => void} [props.onToggle]
 */
export default function CadStockLegend({ items, visibility = null, onToggle = null }) {
  if (!Array.isArray(items) || !items.length) return null;
  const interactive = typeof onToggle === 'function';

  return (
    <div
      style={cadStockLegendRootStyle}
      role="group"
      aria-label={interactive
        ? 'Filtros de estado de lotes'
        : `Estado de lotes: ${items.map((item) => item.label).join(', ')}`}
    >
      {items.map((item) => {
        const active = isCadStockStatusVisible(visibility, item.id);
        if (!interactive) {
          return (
            <span key={item.id} style={cadStockLegendItemStyle}>
              <span
                aria-hidden
                style={{ ...cadStockLegendDotStyle, backgroundColor: item.color }}
              />
              {item.label}
            </span>
          );
        }
        return (
          <button
            key={item.id}
            type="button"
            style={{
              ...cadStockLegendItemButtonStyle,
              opacity: active ? 1 : 0.42,
            }}
            aria-pressed={active}
            aria-label={active
              ? `Ocultar lotes: ${item.label}`
              : `Mostrar lotes: ${item.label}`}
            onClick={() => onToggle(item.id)}
          >
            <span
              aria-hidden
              style={{ ...cadStockLegendDotStyle, backgroundColor: item.color }}
            />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
